









import BaseComponent from '@/components/base-component.vue';
import IPrescription from '@/interfaces/prescription';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PrescriptionFormStatusArea extends BaseComponent {
  @Prop()
  public prescription: IPrescription;

  get status(): any {
    let statusObject;
    if (!this.prescription) {
      statusObject = {};
    } else {
      statusObject = this.getStatus(this.prescription.statusPrescricao);
    }

    return statusObject;
  }

  private getStatus(status: string): any {
    let statusObject;
    switch (status) {
      case prescriptionStatus.WAITING_CLIENT.key:
        statusObject = prescriptionStatus.WAITING_CLIENT;
        break;
      case prescriptionStatus.WAITING_EMEDE.key:
        statusObject = prescriptionStatus.WAITING_EMEDE;
        break;
      case prescriptionStatus.SCHEDULED_PRODUCTION.key:
        statusObject = prescriptionStatus.SCHEDULED_PRODUCTION;
        break;
      case prescriptionStatus.SENT_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.SENT_TO_PRODUCTION;
        break;
      case prescriptionStatus.SENT_PARTIAL_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.SENT_PARTIAL_TO_PRODUCTION;
        break;
      case prescriptionStatus.CANCELED_IN_PRODUCTION.key:
        statusObject = prescriptionStatus.CANCELED_IN_PRODUCTION;
        break;
      case prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE.key:
        statusObject = prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE;
        break;
      case prescriptionStatus.CHECKED_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.CHECKED_TRANSCRIPTION;
        break;
      case prescriptionStatus.WAITING_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.WAITING_TRANSCRIPTION;
        break;
      case prescriptionStatus.DENIED.key:
        statusObject = prescriptionStatus.DENIED;
        break;
      case prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION;
        break;
      default:
        statusObject = {};
    }
    return statusObject;
  }
}
